<template>
  <transition appear name="show-cookie-consent">
    <div class="cookie-consent bg-primary text-default" v-if="isOpen">
      <div class="row padding-2 justify-content-between">
        <div class="col-12 col-md-auto">
          <p v-text="this.text"/>
        </div>
        <div class="col-12 col-md-auto">
          <div class="row justify-content-md-end">
            <div class="col-12 col-md-auto">
              <a  :href="this.url" target="_blank" class="text-italic mr-0 mr-md-2 mb-2 mb-md-0 button-ghost" v-text="this.terms"/>
            </div>
            <div class="col-12 col-md-auto">
              <div @click="accept" class="cookie-consent__button button-ghost text-italic" v-text="this.acceptText"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import * as Cookie from 'tiny-cookie';
import AppConst from '../config/app.const';

export default {
  name: 'CookieConsent',
  data () {
    return {
      supportsLocalStorage: true,
      isOpen: false,
      storageName: AppConst.STORAGE_NAME
    };
  },
  computed: {
    text: function () {
      return this.$store.getters['globals/cookieText'];
    },
    terms: function () {
      return this.$store.getters['globals/cookieTerms'];
    },
    acceptText: function () {
      return this.$store.getters['globals/cookieAccept'];
    },
    url: function () {
      return this.$store.getters['globals/cookieUrl'];
    }
  },
  methods: {
    setVisited () {
      if (this.supportsLocalStorage) {
        localStorage.setItem(this.storageName, true);
      } else {
        Cookie.set(this.storageName, true, { expires: '1Y' });
      }
    },
    setAccepted () {
      if (this.supportsLocalStorage) {
        localStorage.setItem(this.storageName, true);
      } else {
        Cookie.set(this.storageName, true, { expires: '1Y' });
      }
    },
    getVisited () {
      let visited = false;
      if (this.supportsLocalStorage) {
        visited = localStorage.getItem(this.storageName);
      } else {
        visited = Cookie.get(this.storageName);
      }
      if (typeof visited === 'string') {
        visited = JSON.parse(visited);
      }
      return !(visited === null || visited === undefined);
    },
    accept () {
      this.setVisited();
      this.setAccepted();
      this.isOpen = false;
    }
  },
  created () {
    // Check for availability of localStorage
    try {
      const test = '__dtm-cookieconsent-check-localStorage';
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(test, test);
        window.localStorage.removeItem(test);
      }
    } catch (e) {
      // console.info('Local storage is not supported, falling back to cookie use');
      this.supportsLocalStorage = false;
    }
    if (!this.getVisited()) {
      this.isOpen = true;
    }
  }
};
</script>

<style lang="scss" scoped>
  .cookie-consent {
    border-top: 5px solid $color-bg;
    position: fixed;
    z-index: 5;
    right: 0;
    bottom: 0;
    left: 0;
    &__button {
      cursor: pointer;
    }
  }

  .show-cookie-consent-enter, .show-cookie-consent-leave-to {
    transform: translate(0px, 12.500em);
  }
  .show-cookie-consent-enter-to, .show-cookie-consent-leave {
    transform: translate(0px, 0px);
  }
  .show-cookie-consent-enter-active,
  .show-cookie-consent-leave-active, {
    transition: transform .4s ease-in;
  }
</style>
